module.exports = __webpack_public_path__ + "img/rmgridlogoBlue.fc88392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rmgridlogoBlue.png
// module id = s8Vl
// module chunks = 0